import React from "react";
import TextInfo from "@gc-npm/components.text";
import Card from "./card";
import getColor from "@gc-npm/utils.enums.colors";

const TextCard = (props) => {
  const faqKeys = Object.keys(props).filter((key) => /^Faq-\d+$/.test(key));
  const productValues = faqKeys.map((key) => props[key]);

  return (
    
      <><div className="text-card">
      {props["Text-1"] && (
        <TextInfo
          className="text--title"
          {...props["Text-1"]}
          kind="h"
          level="2"
          cyData="Text Title"
          fontType="font-bold" />
      )}

      {productValues &&
        productValues.map((card, index) => (
          <Card {...card} key={`text-card-${index}`} index={index} />
        ))}
    </div><style jsx>
        {`
          .text-card {
            margin-top: 1.5rem;
                     
            border-radius: 16px;
            :global(.text-card-container) {
              margin-bottom: 1.5rem;
            }
            :global(.text--title) {
              margin-bottom: 1.5rem;
            }
            :global(.text-card-description) {
              color: ${getColor("GREY5")} !important;
              margin-top:0.5rem;
              line-height:1.5rem;
            }
          }
        `}
      </style></>
    
  );
};

export default TextCard;
